import { render, staticRenderFns } from "./ModuleItem.vue?vue&type=template&id=3c845a18"
import script from "./ModuleItem.vue?vue&type=script&lang=ts"
export * from "./ModuleItem.vue?vue&type=script&lang=ts"
import style0 from "./ModuleItem.vue?vue&type=style&index=0&id=3c845a18&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports